import { LegalClientHeadEntity } from 'api/types/entity';
import { isFinanceProject, isGlobalProject } from 'config';
import { CountryRiskField } from 'modules/client/common/feature';

import { LegalClientHeadMainInfoType } from '../types';

export const getLegalClientHeadMainInfoForGlobal = (
  client: LegalClientHeadEntity
): LegalClientHeadMainInfoType => ({
  citizenship: client.citizenships?.[0],
  email: client.email,
  position: client.position?.position,
  country: client.residentialAddress?.country,
  countryRiskField: CountryRiskField.ResidentialAddress,
  dateOfExpiration: client.position?.expirationDate,
});

export const getLegalClientHeadMainInfoForFinance = (
  client: LegalClientHeadEntity
): LegalClientHeadMainInfoType => ({
  email: client.email,
  position: client.position?.position,
  country: client.registrationAddress?.country,
  countryRiskField: CountryRiskField.RegistrationAddress,
  dateOfExpiration: client.position?.expirationDate,
});

export const getLegalClientHeadMainInfo = (
  client: LegalClientHeadEntity
): LegalClientHeadMainInfoType | undefined => {
  if (isGlobalProject()) {
    return getLegalClientHeadMainInfoForGlobal(client);
  }
  if (isFinanceProject()) {
    return getLegalClientHeadMainInfoForFinance(client);
  }
  return undefined;
};
